/**
 * Bootstrap for the learner micro-frontend: i18n, store, router, and confirm dialogs.
 */
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ConfirmProvider } from "material-ui-confirm";
import { I18nextProvider } from "react-i18next";
import "react-loading-skeleton/dist/skeleton.css";

import App from "App";
import { AsterControllerProvider } from "context";
import i18n from "i18n";
import { registerServiceWorker } from "offline/register";
import { startSyncListener } from "offline/sync";
import reportWebVitals from "reportWebVitals";
import "./index.scss";

ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={process.env.REACT_APP_APP_BASE_PATH}>
        <AsterControllerProvider>
          <ConfirmProvider>
            <App />
          </ConfirmProvider>
        </AsterControllerProvider>
      </BrowserRouter>
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
registerServiceWorker();
startSyncListener();
reportWebVitals();
